/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type GetCTCoverageDetailsResponse = {
  __typename: "GetCTCoverageDetailsResponse";
  status: GetCTCoverageDetailsResponseStatus;
  addressMissmatch?: boolean | null;
  policyUnitAddress?: string | null;
  residentSiteAddress?: string | null;
  coverage?: Coverage | null;
};

export enum GetCTCoverageDetailsResponseStatus {
  PolicyNotFound = "PolicyNotFound",
  PolicyAlreadyAdded = "PolicyAlreadyAdded",
  AddressMismatch = "AddressMismatch",
  Success = "Success",
}

export type Coverage = {
  __typename: "Coverage";
  id: string;
  agencyAddress?: string | null;
  agencyEmail?: string | null;
  agencyName?: string | null;
  agencyPhoneNumber?: string | null;
  annualCost: number;
  coverageDetails?: CoverageDetails | null;
  createdAt: number;
  documents: Array<CoverageDocument>;
  events: Array<CoverageEvent>;
  insuranceCarrierName: string;
  isActive: boolean;
  isInternalSale?: boolean | null;
  policyCancellationEffectiveDate?: string | null;
  policyCancellationReason?: string | null;
  policyDescription?: string | null;
  policyEffectiveDate: string;
  policyEndDate?: string | null;
  policyEndReason?: string | null;
  policyId: string;
  policyIssuedDate?: string | null;
  policyStatus?: PolicyStatus | null;
  policyType: PolicyType;
  updatedAt: number;
  updatedBy?: string | null;
};

export type CoverageDetails = {
  __typename: "CoverageDetails";
  occupancy?: string | null;
  manufacturer?: string | null;
  homeType?: HomeType | null;
  modelYear?: number | null;
  animalLiabilityLimit?: number | null;
  blanketRentalResidentLiabilityLimit?: number | null;
  homeCoverageLimit?: number | null;
  otherStructuresLimit?: number | null;
  personalLiabilityLimit?: number | null;
  premisesLiabilityLimit?: number | null;
  personalPropertyLimit?: number | null;
  residentLiabilityLimit?: number | null;
  standardDeductibleLimit?: number | null;
  medicalPaymentsLimit?: number | null;
};

export enum HomeType {
  AccessoryDwellingUnit = "AccessoryDwellingUnit",
  DoubleWide = "DoubleWide",
  Duplex = "Duplex",
  CrossMod = "CrossMod",
  Modular = "Modular",
  ParkModel = "ParkModel",
  SingleWide = "SingleWide",
  StationaryTravelTrailer = "StationaryTravelTrailer",
  TinyHome = "TinyHome",
  TripleWide = "TripleWide",
  Unknown = "Unknown",
}

export type CoverageDocument = {
  __typename: "CoverageDocument";
  id: string;
  name: string;
  description?: string | null;
};

export type CoverageEvent = {
  __typename: "CoverageEvent";
  id: string;
  type: CoverageEventType;
  date: string;
  eventData: CoveragePictureForEvent;
};

export enum CoverageEventType {
  AddedActive = "AddedActive",
  AddedInactive = "AddedInactive",
  Cancellation = "Cancellation",
  Endorsement = "Endorsement",
  Reinstatement = "Reinstatement",
  Renewal = "Renewal",
  NonRenewal = "NonRenewal",
}

export type CoveragePictureForEvent = {
  __typename: "CoveragePictureForEvent";
  agencyName?: string | null;
  agencyAddress?: string | null;
  agencyPhoneNumber?: string | null;
  agencyEmail?: string | null;
  isInternalSale?: boolean | null;
  insuranceCarrierName: string;
  isActive: boolean;
  coverageDetails?: CoverageDetails | null;
  policyId: string;
  policyDescription?: string | null;
  termEffectiveDate: string;
  termEndDate: string;
  annualCost: number;
};

export enum PolicyStatus {
  PendingCancellation = "PendingCancellation",
  PendingCancellationEsignRequired = "PendingCancellationEsignRequired",
  PendingCancellationInspection = "PendingCancellationInspection",
  PendingCancellationNonPay = "PendingCancellationNonPay",
  PendingCancellationOther = "PendingCancellationOther",
  PendingEsignRequired = "PendingEsignRequired",
  Activated = "Activated",
  Cancelled = "Cancelled",
  Expired = "Expired",
  InitialQuote = "InitialQuote",
}

export enum PolicyType {
  HomeOwners = "HomeOwners",
  TLL = "TLL",
  External = "External",
}

export type PaginationInput = {
  from?: number | null;
  size?: number | null;
};

export type GetResidentsSortByInput = {
  sortBy: GetResidentsSortBy;
  sort: SortOrder;
};

export enum GetResidentsSortBy {
  ResidentId = "ResidentId",
  Name = "Name",
  SiteAddress = "SiteAddress",
  LotUnit = "LotUnit",
  InsuranceAdoptionStatus = "InsuranceAdoptionStatus",
  CommunityName = "CommunityName",
  PortfolioName = "PortfolioName",
  CreatedDate = "CreatedDate",
  UpdatedDate = "UpdatedDate",
}

export enum SortOrder {
  Ascending = "Ascending",
  Descending = "Descending",
}

export type GetResidentsFilterStatusInput = {
  status: GetResidentsFilterStatus;
};

export enum GetResidentsFilterStatus {
  All = "All",
  PreReview = "PreReview",
  RequirementSatisfied = "RequirementSatisfied",
  RequirementUnsatisfied = "RequirementUnsatisfied",
  UnderReview = "UnderReview",
  Excluded = "Excluded",
}

export type GetResidentsResponse = {
  __typename: "GetResidentsResponse";
  items: Array<Resident>;
  pagination: PaginationResult;
};

export type Resident = {
  __typename: "Resident";
  id: string;
  residentId: string;
  firstName: string;
  lastName: string;
  siteAddress: SiteAddress;
  insuranceAdoption: InsuranceAdoption;
  policyType?: PolicyType | null;
  community: Community;
  createdAt: number;
  updatedAt: number;
  email?: string | null;
  phoneNumber?: string | null;
  isCurrentResident: boolean;
  isPermanentlyExcluded: boolean;
  wasOptedIn?: boolean | null;
  moveInDate: string;
  moveOutDate?: string | null;
  sos?: string | null;
  isNariWorkflowApplicable: boolean;
  lease?: LeaseDetails | null;
  leaseRequirements: LeaseRequirements;
  policyholderLocator?: string | null;
  coverages: Array<Coverage>;
  physicalMailNotificationEvents: Array<PhysicalMailNotificationEvent>;
};

export type SiteAddress = {
  __typename: "SiteAddress";
  addressLine1: string;
  city: string;
  lotUnit?: string | null;
  spaceCode?: string | null;
  state: string;
  type?: string | null;
  zipCode: string;
};

export type InsuranceAdoption = {
  __typename: "InsuranceAdoption";
  description: string;
  status: InsuranceAdoptionStatus;
};

export enum InsuranceAdoptionStatus {
  PreReview = "PreReview",
  RequirementSatisfied = "RequirementSatisfied",
  RequirementUnsatisfied = "RequirementUnsatisfied",
  UnderReview = "UnderReview",
  Excluded = "Excluded",
}

export type Community = {
  __typename: "Community";
  ctmhcId: string;
  integrationId?: string | null;
  integrationType?: PortfolioIntegrationType | null;
  isActive: boolean;
  legalEntityCommunityOwnerId: string;
  name: string;
  portfolio: Portfolio;
  displayId?: string | null;
  propertyId: string;
};

export enum PortfolioIntegrationType {
  RentManager = "RentManager",
  ManageAmerica = "ManageAmerica",
  Yardi = "Yardi",
  AppFolio = "AppFolio",
}

export type Portfolio = {
  __typename: "Portfolio";
  id: string;
  integrationId?: string | null;
  integrationType?: PortfolioIntegrationType | null;
  isActive: boolean;
  name: string;
};

export type LeaseDetails = {
  __typename: "LeaseDetails";
  addendumDate?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  description?: string | null;
};

export type LeaseRequirements = {
  __typename: "LeaseRequirements";
  animalLiabilityLimit: number;
  leaseLimit: number;
  medicalPaymentsLimit: number;
};

export type PhysicalMailNotificationEvent = {
  __typename: "PhysicalMailNotificationEvent";
  id: string;
  additionalData: string;
  eventType: PhysicalMailEventType;
  eventDate: string;
};

export enum PhysicalMailEventType {
  LetterCreated = "LetterCreated",
  InTransit = "InTransit",
  InLocalArea = "InLocalArea",
  Delivered = "Delivered",
  ProcessedForDelivery = "ProcessedForDelivery",
  ReturnToSender = "ReturnToSender",
  ReRouted = "ReRouted",
  Mailed = "Mailed",
}

export type PaginationResult = {
  __typename: "PaginationResult";
  from: number;
  size: number;
  total: number;
};

export type SaveCommunityConfigurationInput = {
  action: CommunityConfigurationAction;
  communities: Array<CommunityConfigurationCommunityInput>;
  owners: Array<CommunityConfigurationOwnerInput>;
  policyDefaults?: CommunityConfigurationPolicyDefaultsInput | null;
  portfolioId: string;
  rentManagerLocations?: Array<CommunityConfigurationRentManagerLocationInput> | null;
  rentManagerSettings?: CommunityConfigurationRentManagerSettingsInput | null;
  states: Array<CommunityConfigurationStateInput>;
};

export enum CommunityConfigurationAction {
  ACTIVATE = "ACTIVATE",
  SAVE_DRAFT = "SAVE_DRAFT",
}

export type CommunityConfigurationCommunityInput = {
  ctmhcId?: string | null;
  // Addendum date applied to every resident of the community imported from an
  // integration that does not provide one (Rent Manager).
  defaultAddendumDate?: string | null;
  isActive: boolean;
  ownerClientId?: string | null;
  propertyId: string;
};

export type CommunityConfigurationOwnerInput = {
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  clientId: string;
  county?: string | null;
  id?: string | null;
  municipality?: string | null;
  name?: string | null;
  state?: string | null;
  zipCode?: string | null;
};

export type CommunityConfigurationPolicyDefaultsInput = {
  limits?: CommunityConfigurationPolicyLimitsInput | null;
  mgaFee?: number | null;
  operatorFee?: number | null;
  pricePerUnit?: number | null;
};

export type CommunityConfigurationPolicyLimitsInput = {
  animalLiabilityLimit?: number | null;
  blanketRentalResidentLiabilityLimit?: number | null;
  medicalPaymentsLimit?: number | null;
  premisesLiabilityLimit?: number | null;
};

export type CommunityConfigurationRentManagerLocationInput = {
  glAccountId?: number | null;
  locationId: number;
};

export type CommunityConfigurationRentManagerSettingsInput = {
  liveNotesEnabled: boolean;
  shouldWriteDefaultUDFValues: boolean;
};

export type CommunityConfigurationStateInput = {
  localTaxes: Array<CommunityConfigurationLocalTaxesInput>;
  policyNumbers: Array<CommunityConfigurationPolicyNumberInput>;
  stampingFee?: number | null;
  state: string;
  stateTax?: number | null;
  surplusLinesTax?: number | null;
};

export type CommunityConfigurationLocalTaxesInput = {
  cityName?: string | null;
  cityTaxRate?: number | null;
  countyName?: string | null;
  countyTaxRate?: number | null;
  otherLocalTaxes?: Array<CommunityConfigurationOtherLocalTaxInput> | null;
  ownerClientId: string;
};

export type CommunityConfigurationOtherLocalTaxInput = {
  name: string;
  rate: number;
};

export type CommunityConfigurationPolicyNumberInput = {
  ownerClientId: string;
  policyNumber?: string | null;
};

export type SaveCommunityConfigurationPayload = {
  __typename: "SaveCommunityConfigurationPayload";
  configuration: CommunityConfiguration;
  issues: Array<CommunityConfigurationIssue>;
  ownerMappings: Array<CommunityConfigurationOwnerMapping>;
  saved: boolean;
  status: string;
};

export type CommunityConfiguration = {
  __typename: "CommunityConfiguration";
  communities: Array<CommunityConfigurationCommunity>;
  effectiveDate: string;
  effectiveTimestamp: number;
  owners: Array<CommunityConfigurationOwner>;
  policyDefaults?: CommunityConfigurationPolicyDefaults | null;
  portfolio: CommunityConfigurationPortfolio;
  states: Array<CommunityConfigurationState>;
  taxDefaults: Array<CommunityConfigurationTaxDefault>;
};

export type CommunityConfigurationCommunity = {
  __typename: "CommunityConfigurationCommunity";
  addressLine1: string;
  addressLine2?: string | null;
  city: string;
  ctmhcId?: string | null;
  defaultAddendumDate?: string | null;
  displayId: string;
  isActive: boolean;
  name: string;
  ownerClientId?: string | null;
  propertyId: string;
  state: string;
  zipCode: string;
};

export type CommunityConfigurationOwner = {
  __typename: "CommunityConfigurationOwner";
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  clientId: string;
  county?: string | null;
  id?: string | null;
  municipality?: string | null;
  name?: string | null;
  state?: string | null;
  zipCode?: string | null;
};

export type CommunityConfigurationPolicyDefaults = {
  __typename: "CommunityConfigurationPolicyDefaults";
  limits: CommunityConfigurationPolicyLimits;
  mgaFee: number;
  operatorFee: number;
  pricePerUnit: number;
};

export type CommunityConfigurationPolicyLimits = {
  __typename: "CommunityConfigurationPolicyLimits";
  animalLiabilityLimit?: number | null;
  blanketRentalResidentLiabilityLimit: number;
  medicalPaymentsLimit?: number | null;
  premisesLiabilityLimit?: number | null;
};

export type CommunityConfigurationPortfolio = {
  __typename: "CommunityConfigurationPortfolio";
  addressLine1: string;
  addressLine2?: string | null;
  city: string;
  county?: string | null;
  id: string;
  integrationId?: string | null;
  integrationType?: PortfolioIntegrationType | null;
  isActive: boolean;
  name: string;
  rentManagerLocations?: Array<CommunityConfigurationRentManagerLocation> | null;
  rentManagerSettings?: CommunityConfigurationRentManagerSettings | null;
  state: string;
  zipCode: string;
};

export type CommunityConfigurationRentManagerLocation = {
  __typename: "CommunityConfigurationRentManagerLocation";
  glAccountId?: number | null;
  id: number;
  name: string;
};

export type CommunityConfigurationRentManagerSettings = {
  __typename: "CommunityConfigurationRentManagerSettings";
  liveNotesEnabled: boolean;
  shouldWriteDefaultUDFValues: boolean;
};

export type CommunityConfigurationState = {
  __typename: "CommunityConfigurationState";
  localTaxes: Array<CommunityConfigurationLocalTaxes>;
  policyNumbers: Array<CommunityConfigurationPolicyNumber>;
  stampingFee?: number | null;
  state: string;
  stateTax?: number | null;
  surplusLinesTax: number;
};

export type CommunityConfigurationLocalTaxes = {
  __typename: "CommunityConfigurationLocalTaxes";
  cityName?: string | null;
  cityTaxRate?: number | null;
  countyName?: string | null;
  countyTaxRate?: number | null;
  otherLocalTaxes: Array<CommunityConfigurationOtherLocalTax>;
  ownerClientId: string;
};

export type CommunityConfigurationOtherLocalTax = {
  __typename: "CommunityConfigurationOtherLocalTax";
  name: string;
  rate: number;
};

export type CommunityConfigurationPolicyNumber = {
  __typename: "CommunityConfigurationPolicyNumber";
  ownerClientId: string;
  policyNumber?: string | null;
};

export type CommunityConfigurationTaxDefault = {
  __typename: "CommunityConfigurationTaxDefault";
  otherFee?: CommunityConfigurationOtherFee | null;
  stampingFee?: number | null;
  state: string;
  stateTax?: number | null;
  surplusLinesTax: number;
};

export type CommunityConfigurationOtherFee = {
  __typename: "CommunityConfigurationOtherFee";
  name: string;
  rate: number;
};

export type CommunityConfigurationIssue = {
  __typename: "CommunityConfigurationIssue";
  code: string;
  message: string;
  path: string;
  severity: CommunityConfigurationIssueSeverity;
};

export enum CommunityConfigurationIssueSeverity {
  ERROR = "ERROR",
  WARNING = "WARNING",
}

export type CommunityConfigurationOwnerMapping = {
  __typename: "CommunityConfigurationOwnerMapping";
  clientId: string;
  id: string;
};

export type PortfolioInput = {
  addressLine1: string;
  addressLine2?: string | null;
  city: string;
  county: string;
  createResidentHubspotLeadOnImport: boolean;
  delayToStartUnderReviewTimePeriodAfterCancellationOrExpirationInDays: number;
  emailAddresses: Array<string>;
  firstDocumentReminderDelayInDays?: number | null;
  id?: string | null;
  integrationId: string;
  integrationType: PortfolioIntegrationType;
  managersName: string;
  minUnderReviewTimePeriodInDays: number;
  name: string;
  secondDocumentReminderDelayInDays: number;
  sendInitialDocumentUploadReminders: boolean;
  state: string;
  syncAddressData: boolean;
  thirdDocumentReminderDelayInDays: number;
  zipCode: string;
};

export type ExternalPolicyDetailsInput = {
  policyId: string;
  insuranceCarrierName: string;
  policyEffectiveDate: string;
  policyEndDate: string;
  annualCost: number;
  agencyName?: string | null;
  agencyAddress?: string | null;
  agencyPhoneNumber?: string | null;
  agencyEmail?: string | null;
  isInternalSale?: boolean | null;
  policyDescription?: string | null;
  coverageDetails?: CoverageDetailsInput | null;
};

export type CoverageDetailsInput = {
  homeType?: HomeType | null;
  modelYear?: number | null;
  occupancy: string;
  manufacturer?: string | null;
  personalLiabilityLimit: number;
  homeCoverageLimit?: number | null;
  otherStructuresLimit?: number | null;
  personalPropertyLimit?: number | null;
  standardDeductibleLimit?: number | null;
  medicalPaymentsLimit?: number | null;
  animalLiabilityLimit?: number | null;
};

export type AddCoverageDetails = {
  __typename: "AddCoverageDetails";
  resident: Resident;
  alreadyAddedCoverageId?: string | null;
  alreadyAddedCoverageStatus?: TllCoverageStatus | null;
  cancelledCoverage?: Coverage | null;
  residentStatusChanged?: boolean | null;
};

export enum TllCoverageStatus {
  Active = "Active",
  Scheduled = "Scheduled",
  Cancelled = "Cancelled",
  ScheduledCancellation = "ScheduledCancellation",
}

export type CoverageEventInput = {
  agencyAddress?: string | null;
  agencyEmail?: string | null;
  agencyName?: string | null;
  agencyPhoneNumber?: string | null;
  annualCost: number;
  coverageDetails?: CoverageDetailsInput | null;
  insuranceCarrierName: string;
  isInternalSale?: boolean | null;
  policyDescription?: string | null;
  policyId: string;
  termEffectiveDate: string;
  termEndDate: string;
  type: CoverageEventType;
};

export type ComplianceReview = {
  __typename: "ComplianceReview";
  id: string;
  startedAt: string;
  startReason: string;
  endedAt?: string | null;
  endReason?: string | null;
  expectedEndDate?: string | null;
};

export enum ParameterName {
  CommunityName = "CommunityName",
  Manufacturer = "Manufacturer",
}

export type RentManagerGeneralLedgerAccount = {
  __typename: "RentManagerGeneralLedgerAccount";
  description?: string | null;
  id: number;
  isActive: boolean;
  name: string;
};

export type GetProofOfCoverageDetailsMutationVariables = {
  policyLocator: string;
  residentId: string;
};

export type GetProofOfCoverageDetailsMutation = {
  getCtCoverageDetails: {
    __typename: "GetCTCoverageDetailsResponse";
    status: GetCTCoverageDetailsResponseStatus;
    addressMissmatch?: boolean | null;
    policyUnitAddress?: string | null;
    residentSiteAddress?: string | null;
    coverage?: {
      __typename: "Coverage";
      id: string;
      agencyName?: string | null;
      agencyAddress?: string | null;
      agencyPhoneNumber?: string | null;
      agencyEmail?: string | null;
      insuranceCarrierName: string;
      isActive: boolean;
      coverageDetails?: {
        __typename: "CoverageDetails";
        occupancy?: string | null;
        homeType?: HomeType | null;
        manufacturer?: string | null;
        modelYear?: number | null;
        animalLiabilityLimit?: number | null;
        homeCoverageLimit?: number | null;
        otherStructuresLimit?: number | null;
        personalLiabilityLimit?: number | null;
        personalPropertyLimit?: number | null;
        residentLiabilityLimit?: number | null;
        standardDeductibleLimit?: number | null;
        medicalPaymentsLimit?: number | null;
      } | null;
      policyType: PolicyType;
      policyId: string;
      policyDescription?: string | null;
      policyStatus?: PolicyStatus | null;
      policyEffectiveDate: string;
      policyEndDate?: string | null;
      annualCost: number;
    } | null;
  };
};

export type GetResidentsListItemsQueryVariables = {
  pagination?: PaginationInput | null;
  sorting?: GetResidentsSortByInput | null;
  filter?: GetResidentsFilterStatusInput | null;
};

export type GetResidentsListItemsQuery = {
  getResidents: {
    __typename: "GetResidentsResponse";
    items: Array<{
      __typename: "Resident";
      id: string;
      firstName: string;
      lastName: string;
      siteAddress: {
        __typename: "SiteAddress";
        addressLine1: string;
        city: string;
        lotUnit?: string | null;
        state: string;
        zipCode: string;
      };
      insuranceAdoption: {
        __typename: "InsuranceAdoption";
        status: InsuranceAdoptionStatus;
      };
      policyType?: PolicyType | null;
      community: {
        __typename: "Community";
        name: string;
        portfolio: {
          __typename: "Portfolio";
          name: string;
        };
      };
      createdAt: number;
      updatedAt: number;
      residentId: string;
    }>;
    pagination: {
      __typename: "PaginationResult";
      from: number;
      size: number;
      total: number;
    };
  };
};

export type SearchResidentsListQueryQueryVariables = {
  pagination?: PaginationInput | null;
  query: string;
};

export type SearchResidentsListQueryQuery = {
  searchResidents: {
    __typename: "GetResidentsResponse";
    items: Array<{
      __typename: "Resident";
      id: string;
      firstName: string;
      lastName: string;
      siteAddress: {
        __typename: "SiteAddress";
        addressLine1: string;
        city: string;
        lotUnit?: string | null;
        state: string;
        zipCode: string;
      };
      insuranceAdoption: {
        __typename: "InsuranceAdoption";
        status: InsuranceAdoptionStatus;
      };
      policyType?: PolicyType | null;
      community: {
        __typename: "Community";
        name: string;
        portfolio: {
          __typename: "Portfolio";
          name: string;
        };
      };
      createdAt: number;
      updatedAt: number;
      residentId: string;
    }>;
    pagination: {
      __typename: "PaginationResult";
      from: number;
      size: number;
      total: number;
    };
  };
};

export type GetResidentBasicDataQuery = {
  getResident: {
    __typename: "Resident";
    id: string;
    firstName: string;
    lastName: string;
    siteAddress: {
      __typename: "SiteAddress";
      addressLine1: string;
      city: string;
      lotUnit?: string | null;
      state: string;
      zipCode: string;
    };
    insuranceAdoption: {
      __typename: "InsuranceAdoption";
      status: InsuranceAdoptionStatus;
    };
    community: {
      __typename: "Community";
      name: string;
    };
    createdAt: number;
    updatedAt: number;
    phoneNumber?: string | null;
    email?: string | null;
    residentId: string;
  };
};

export type GetManufacturersQueryVariables = {
  search: string;
};

export type GetManufacturersQuery = {
  getParameters: Array<string>;
};

export type ToggleCommunityActiveStatusMutationVariables = {
  portfolioId: string;
  propertyId: string;
};

export type ToggleCommunityActiveStatusMutation = {
  toggleCommunityActiveStatus: {
    __typename: "Community";
    ctmhcId: string;
    integrationId?: string | null;
    integrationType?: PortfolioIntegrationType | null;
    isActive: boolean;
    legalEntityCommunityOwnerId: string;
    name: string;
    portfolio: {
      __typename: "Portfolio";
      id: string;
      integrationId?: string | null;
      integrationType?: PortfolioIntegrationType | null;
      isActive: boolean;
      name: string;
    };
    displayId?: string | null;
    propertyId: string;
  };
};

export type SetResidentPermanentExclusionMutationVariables = {
  id: string;
  isPermanentlyExcluded: boolean;
};

export type SetResidentPermanentExclusionMutation = {
  setResidentPermanentExclusion: {
    __typename: "Resident";
    id: string;
    residentId: string;
    firstName: string;
    lastName: string;
    siteAddress: {
      __typename: "SiteAddress";
      addressLine1: string;
      city: string;
      lotUnit?: string | null;
      spaceCode?: string | null;
      state: string;
      type?: string | null;
      zipCode: string;
    };
    insuranceAdoption: {
      __typename: "InsuranceAdoption";
      description: string;
      status: InsuranceAdoptionStatus;
    };
    policyType?: PolicyType | null;
    community: {
      __typename: "Community";
      ctmhcId: string;
      integrationId?: string | null;
      integrationType?: PortfolioIntegrationType | null;
      isActive: boolean;
      legalEntityCommunityOwnerId: string;
      name: string;
      portfolio: {
        __typename: "Portfolio";
        id: string;
        integrationId?: string | null;
        integrationType?: PortfolioIntegrationType | null;
        isActive: boolean;
        name: string;
      };
      displayId?: string | null;
      propertyId: string;
    };
    createdAt: number;
    updatedAt: number;
    email?: string | null;
    phoneNumber?: string | null;
    isCurrentResident: boolean;
    isPermanentlyExcluded: boolean;
    wasOptedIn?: boolean | null;
    moveInDate: string;
    moveOutDate?: string | null;
    sos?: string | null;
    isNariWorkflowApplicable: boolean;
    lease?: {
      __typename: "LeaseDetails";
      addendumDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      description?: string | null;
    } | null;
    leaseRequirements: {
      __typename: "LeaseRequirements";
      animalLiabilityLimit: number;
      leaseLimit: number;
      medicalPaymentsLimit: number;
    };
    policyholderLocator?: string | null;
    coverages: Array<{
      __typename: "Coverage";
      id: string;
      agencyAddress?: string | null;
      agencyEmail?: string | null;
      agencyName?: string | null;
      agencyPhoneNumber?: string | null;
      annualCost: number;
      coverageDetails?: {
        __typename: "CoverageDetails";
        occupancy?: string | null;
        manufacturer?: string | null;
        homeType?: HomeType | null;
        modelYear?: number | null;
        animalLiabilityLimit?: number | null;
        blanketRentalResidentLiabilityLimit?: number | null;
        homeCoverageLimit?: number | null;
        otherStructuresLimit?: number | null;
        personalLiabilityLimit?: number | null;
        premisesLiabilityLimit?: number | null;
        personalPropertyLimit?: number | null;
        residentLiabilityLimit?: number | null;
        standardDeductibleLimit?: number | null;
        medicalPaymentsLimit?: number | null;
      } | null;
      createdAt: number;
      documents: Array<{
        __typename: "CoverageDocument";
        id: string;
        name: string;
        description?: string | null;
      }>;
      events: Array<{
        __typename: "CoverageEvent";
        id: string;
        type: CoverageEventType;
        date: string;
        eventData: {
          __typename: "CoveragePictureForEvent";
          agencyName?: string | null;
          agencyAddress?: string | null;
          agencyPhoneNumber?: string | null;
          agencyEmail?: string | null;
          isInternalSale?: boolean | null;
          insuranceCarrierName: string;
          isActive: boolean;
          coverageDetails?: {
            __typename: "CoverageDetails";
            occupancy?: string | null;
            manufacturer?: string | null;
            homeType?: HomeType | null;
            modelYear?: number | null;
            animalLiabilityLimit?: number | null;
            blanketRentalResidentLiabilityLimit?: number | null;
            homeCoverageLimit?: number | null;
            otherStructuresLimit?: number | null;
            personalLiabilityLimit?: number | null;
            premisesLiabilityLimit?: number | null;
            personalPropertyLimit?: number | null;
            residentLiabilityLimit?: number | null;
            standardDeductibleLimit?: number | null;
            medicalPaymentsLimit?: number | null;
          } | null;
          policyId: string;
          policyDescription?: string | null;
          termEffectiveDate: string;
          termEndDate: string;
          annualCost: number;
        };
      }>;
      insuranceCarrierName: string;
      isActive: boolean;
      isInternalSale?: boolean | null;
      policyCancellationEffectiveDate?: string | null;
      policyCancellationReason?: string | null;
      policyDescription?: string | null;
      policyEffectiveDate: string;
      policyEndDate?: string | null;
      policyEndReason?: string | null;
      policyId: string;
      policyIssuedDate?: string | null;
      policyStatus?: PolicyStatus | null;
      policyType: PolicyType;
      updatedAt: number;
      updatedBy?: string | null;
    }>;
    physicalMailNotificationEvents: Array<{
      __typename: "PhysicalMailNotificationEvent";
      id: string;
      additionalData: string;
      eventType: PhysicalMailEventType;
      eventDate: string;
    }>;
  };
};

export type IssueTLLForResidentMutationVariables = {
  id: string;
};

export type IssueTLLForResidentMutation = {
  issueTLLForResident: {
    __typename: "Resident";
    id: string;
    residentId: string;
    firstName: string;
    lastName: string;
    siteAddress: {
      __typename: "SiteAddress";
      addressLine1: string;
      city: string;
      lotUnit?: string | null;
      spaceCode?: string | null;
      state: string;
      type?: string | null;
      zipCode: string;
    };
    insuranceAdoption: {
      __typename: "InsuranceAdoption";
      description: string;
      status: InsuranceAdoptionStatus;
    };
    policyType?: PolicyType | null;
    community: {
      __typename: "Community";
      ctmhcId: string;
      integrationId?: string | null;
      integrationType?: PortfolioIntegrationType | null;
      isActive: boolean;
      legalEntityCommunityOwnerId: string;
      name: string;
      portfolio: {
        __typename: "Portfolio";
        id: string;
        integrationId?: string | null;
        integrationType?: PortfolioIntegrationType | null;
        isActive: boolean;
        name: string;
      };
      displayId?: string | null;
      propertyId: string;
    };
    createdAt: number;
    updatedAt: number;
    email?: string | null;
    phoneNumber?: string | null;
    isCurrentResident: boolean;
    isPermanentlyExcluded: boolean;
    wasOptedIn?: boolean | null;
    moveInDate: string;
    moveOutDate?: string | null;
    sos?: string | null;
    isNariWorkflowApplicable: boolean;
    lease?: {
      __typename: "LeaseDetails";
      addendumDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      description?: string | null;
    } | null;
    leaseRequirements: {
      __typename: "LeaseRequirements";
      animalLiabilityLimit: number;
      leaseLimit: number;
      medicalPaymentsLimit: number;
    };
    policyholderLocator?: string | null;
    coverages: Array<{
      __typename: "Coverage";
      id: string;
      agencyAddress?: string | null;
      agencyEmail?: string | null;
      agencyName?: string | null;
      agencyPhoneNumber?: string | null;
      annualCost: number;
      coverageDetails?: {
        __typename: "CoverageDetails";
        occupancy?: string | null;
        manufacturer?: string | null;
        homeType?: HomeType | null;
        modelYear?: number | null;
        animalLiabilityLimit?: number | null;
        blanketRentalResidentLiabilityLimit?: number | null;
        homeCoverageLimit?: number | null;
        otherStructuresLimit?: number | null;
        personalLiabilityLimit?: number | null;
        premisesLiabilityLimit?: number | null;
        personalPropertyLimit?: number | null;
        residentLiabilityLimit?: number | null;
        standardDeductibleLimit?: number | null;
        medicalPaymentsLimit?: number | null;
      } | null;
      createdAt: number;
      documents: Array<{
        __typename: "CoverageDocument";
        id: string;
        name: string;
        description?: string | null;
      }>;
      events: Array<{
        __typename: "CoverageEvent";
        id: string;
        type: CoverageEventType;
        date: string;
        eventData: {
          __typename: "CoveragePictureForEvent";
          agencyName?: string | null;
          agencyAddress?: string | null;
          agencyPhoneNumber?: string | null;
          agencyEmail?: string | null;
          isInternalSale?: boolean | null;
          insuranceCarrierName: string;
          isActive: boolean;
          coverageDetails?: {
            __typename: "CoverageDetails";
            occupancy?: string | null;
            manufacturer?: string | null;
            homeType?: HomeType | null;
            modelYear?: number | null;
            animalLiabilityLimit?: number | null;
            blanketRentalResidentLiabilityLimit?: number | null;
            homeCoverageLimit?: number | null;
            otherStructuresLimit?: number | null;
            personalLiabilityLimit?: number | null;
            premisesLiabilityLimit?: number | null;
            personalPropertyLimit?: number | null;
            residentLiabilityLimit?: number | null;
            standardDeductibleLimit?: number | null;
            medicalPaymentsLimit?: number | null;
          } | null;
          policyId: string;
          policyDescription?: string | null;
          termEffectiveDate: string;
          termEndDate: string;
          annualCost: number;
        };
      }>;
      insuranceCarrierName: string;
      isActive: boolean;
      isInternalSale?: boolean | null;
      policyCancellationEffectiveDate?: string | null;
      policyCancellationReason?: string | null;
      policyDescription?: string | null;
      policyEffectiveDate: string;
      policyEndDate?: string | null;
      policyEndReason?: string | null;
      policyId: string;
      policyIssuedDate?: string | null;
      policyStatus?: PolicyStatus | null;
      policyType: PolicyType;
      updatedAt: number;
      updatedBy?: string | null;
    }>;
    physicalMailNotificationEvents: Array<{
      __typename: "PhysicalMailNotificationEvent";
      id: string;
      additionalData: string;
      eventType: PhysicalMailEventType;
      eventDate: string;
    }>;
  };
};

export type GetCtCoverageDetailsMutationVariables = {
  policyLocator: string;
  residentId: string;
};

export type GetCtCoverageDetailsMutation = {
  getCtCoverageDetails: {
    __typename: "GetCTCoverageDetailsResponse";
    status: GetCTCoverageDetailsResponseStatus;
    addressMissmatch?: boolean | null;
    policyUnitAddress?: string | null;
    residentSiteAddress?: string | null;
    coverage?: {
      __typename: "Coverage";
      id: string;
      agencyAddress?: string | null;
      agencyEmail?: string | null;
      agencyName?: string | null;
      agencyPhoneNumber?: string | null;
      annualCost: number;
      coverageDetails?: {
        __typename: "CoverageDetails";
        occupancy?: string | null;
        manufacturer?: string | null;
        homeType?: HomeType | null;
        modelYear?: number | null;
        animalLiabilityLimit?: number | null;
        blanketRentalResidentLiabilityLimit?: number | null;
        homeCoverageLimit?: number | null;
        otherStructuresLimit?: number | null;
        personalLiabilityLimit?: number | null;
        premisesLiabilityLimit?: number | null;
        personalPropertyLimit?: number | null;
        residentLiabilityLimit?: number | null;
        standardDeductibleLimit?: number | null;
        medicalPaymentsLimit?: number | null;
      } | null;
      createdAt: number;
      documents: Array<{
        __typename: "CoverageDocument";
        id: string;
        name: string;
        description?: string | null;
      }>;
      events: Array<{
        __typename: "CoverageEvent";
        id: string;
        type: CoverageEventType;
        date: string;
        eventData: {
          __typename: "CoveragePictureForEvent";
          agencyName?: string | null;
          agencyAddress?: string | null;
          agencyPhoneNumber?: string | null;
          agencyEmail?: string | null;
          isInternalSale?: boolean | null;
          insuranceCarrierName: string;
          isActive: boolean;
          coverageDetails?: {
            __typename: "CoverageDetails";
            occupancy?: string | null;
            manufacturer?: string | null;
            homeType?: HomeType | null;
            modelYear?: number | null;
            animalLiabilityLimit?: number | null;
            blanketRentalResidentLiabilityLimit?: number | null;
            homeCoverageLimit?: number | null;
            otherStructuresLimit?: number | null;
            personalLiabilityLimit?: number | null;
            premisesLiabilityLimit?: number | null;
            personalPropertyLimit?: number | null;
            residentLiabilityLimit?: number | null;
            standardDeductibleLimit?: number | null;
            medicalPaymentsLimit?: number | null;
          } | null;
          policyId: string;
          policyDescription?: string | null;
          termEffectiveDate: string;
          termEndDate: string;
          annualCost: number;
        };
      }>;
      insuranceCarrierName: string;
      isActive: boolean;
      isInternalSale?: boolean | null;
      policyCancellationEffectiveDate?: string | null;
      policyCancellationReason?: string | null;
      policyDescription?: string | null;
      policyEffectiveDate: string;
      policyEndDate?: string | null;
      policyEndReason?: string | null;
      policyId: string;
      policyIssuedDate?: string | null;
      policyStatus?: PolicyStatus | null;
      policyType: PolicyType;
      updatedAt: number;
      updatedBy?: string | null;
    } | null;
  };
};

export type SaveCommunityConfigurationMutationVariables = {
  configuration: SaveCommunityConfigurationInput;
};

export type SaveCommunityConfigurationMutation = {
  saveCommunityConfiguration: {
    __typename: "SaveCommunityConfigurationPayload";
    configuration: {
      __typename: "CommunityConfiguration";
      communities: Array<{
        __typename: "CommunityConfigurationCommunity";
        addressLine1: string;
        addressLine2?: string | null;
        city: string;
        ctmhcId?: string | null;
        defaultAddendumDate?: string | null;
        displayId: string;
        isActive: boolean;
        name: string;
        ownerClientId?: string | null;
        propertyId: string;
        state: string;
        zipCode: string;
      }>;
      effectiveDate: string;
      effectiveTimestamp: number;
      owners: Array<{
        __typename: "CommunityConfigurationOwner";
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        clientId: string;
        county?: string | null;
        id?: string | null;
        municipality?: string | null;
        name?: string | null;
        state?: string | null;
        zipCode?: string | null;
      }>;
      policyDefaults?: {
        __typename: "CommunityConfigurationPolicyDefaults";
        limits: {
          __typename: "CommunityConfigurationPolicyLimits";
          animalLiabilityLimit?: number | null;
          blanketRentalResidentLiabilityLimit: number;
          medicalPaymentsLimit?: number | null;
          premisesLiabilityLimit?: number | null;
        };
        mgaFee: number;
        operatorFee: number;
        pricePerUnit: number;
      } | null;
      portfolio: {
        __typename: "CommunityConfigurationPortfolio";
        addressLine1: string;
        addressLine2?: string | null;
        city: string;
        county?: string | null;
        id: string;
        integrationId?: string | null;
        integrationType?: PortfolioIntegrationType | null;
        isActive: boolean;
        name: string;
        rentManagerLocations?: Array<{
          __typename: "CommunityConfigurationRentManagerLocation";
          glAccountId?: number | null;
          id: number;
          name: string;
        }> | null;
        rentManagerSettings?: {
          __typename: "CommunityConfigurationRentManagerSettings";
          liveNotesEnabled: boolean;
          shouldWriteDefaultUDFValues: boolean;
        } | null;
        state: string;
        zipCode: string;
      };
      states: Array<{
        __typename: "CommunityConfigurationState";
        localTaxes: Array<{
          __typename: "CommunityConfigurationLocalTaxes";
          cityName?: string | null;
          cityTaxRate?: number | null;
          countyName?: string | null;
          countyTaxRate?: number | null;
          otherLocalTaxes: Array<{
            __typename: "CommunityConfigurationOtherLocalTax";
            name: string;
            rate: number;
          }>;
          ownerClientId: string;
        }>;
        policyNumbers: Array<{
          __typename: "CommunityConfigurationPolicyNumber";
          ownerClientId: string;
          policyNumber?: string | null;
        }>;
        stampingFee?: number | null;
        state: string;
        stateTax?: number | null;
        surplusLinesTax: number;
      }>;
      taxDefaults: Array<{
        __typename: "CommunityConfigurationTaxDefault";
        otherFee?: {
          __typename: "CommunityConfigurationOtherFee";
          name: string;
          rate: number;
        } | null;
        stampingFee?: number | null;
        state: string;
        stateTax?: number | null;
        surplusLinesTax: number;
      }>;
    };
    issues: Array<{
      __typename: "CommunityConfigurationIssue";
      code: string;
      message: string;
      path: string;
      severity: CommunityConfigurationIssueSeverity;
    }>;
    ownerMappings: Array<{
      __typename: "CommunityConfigurationOwnerMapping";
      clientId: string;
      id: string;
    }>;
    saved: boolean;
    status: string;
  };
};

export type CancelTllCoverageMutationVariables = {
  coverageId: string;
  residentId: string;
};

export type CancelTllCoverageMutation = {
  cancelTllCoverage: {
    __typename: "Coverage";
    id: string;
    agencyAddress?: string | null;
    agencyEmail?: string | null;
    agencyName?: string | null;
    agencyPhoneNumber?: string | null;
    annualCost: number;
    coverageDetails?: {
      __typename: "CoverageDetails";
      occupancy?: string | null;
      manufacturer?: string | null;
      homeType?: HomeType | null;
      modelYear?: number | null;
      animalLiabilityLimit?: number | null;
      blanketRentalResidentLiabilityLimit?: number | null;
      homeCoverageLimit?: number | null;
      otherStructuresLimit?: number | null;
      personalLiabilityLimit?: number | null;
      premisesLiabilityLimit?: number | null;
      personalPropertyLimit?: number | null;
      residentLiabilityLimit?: number | null;
      standardDeductibleLimit?: number | null;
      medicalPaymentsLimit?: number | null;
    } | null;
    createdAt: number;
    documents: Array<{
      __typename: "CoverageDocument";
      id: string;
      name: string;
      description?: string | null;
    }>;
    events: Array<{
      __typename: "CoverageEvent";
      id: string;
      type: CoverageEventType;
      date: string;
      eventData: {
        __typename: "CoveragePictureForEvent";
        agencyName?: string | null;
        agencyAddress?: string | null;
        agencyPhoneNumber?: string | null;
        agencyEmail?: string | null;
        isInternalSale?: boolean | null;
        insuranceCarrierName: string;
        isActive: boolean;
        coverageDetails?: {
          __typename: "CoverageDetails";
          occupancy?: string | null;
          manufacturer?: string | null;
          homeType?: HomeType | null;
          modelYear?: number | null;
          animalLiabilityLimit?: number | null;
          blanketRentalResidentLiabilityLimit?: number | null;
          homeCoverageLimit?: number | null;
          otherStructuresLimit?: number | null;
          personalLiabilityLimit?: number | null;
          premisesLiabilityLimit?: number | null;
          personalPropertyLimit?: number | null;
          residentLiabilityLimit?: number | null;
          standardDeductibleLimit?: number | null;
          medicalPaymentsLimit?: number | null;
        } | null;
        policyId: string;
        policyDescription?: string | null;
        termEffectiveDate: string;
        termEndDate: string;
        annualCost: number;
      };
    }>;
    insuranceCarrierName: string;
    isActive: boolean;
    isInternalSale?: boolean | null;
    policyCancellationEffectiveDate?: string | null;
    policyCancellationReason?: string | null;
    policyDescription?: string | null;
    policyEffectiveDate: string;
    policyEndDate?: string | null;
    policyEndReason?: string | null;
    policyId: string;
    policyIssuedDate?: string | null;
    policyStatus?: PolicyStatus | null;
    policyType: PolicyType;
    updatedAt: number;
    updatedBy?: string | null;
  };
};

export type AddNewPortfolioMutationVariables = {
  portfolio: PortfolioInput;
};

export type AddNewPortfolioMutation = {
  addNewPortfolio: boolean;
};

export type AddExternalCoverageMutationVariables = {
  policy: ExternalPolicyDetailsInput;
  residentId: string;
  documentIds?: Array<string> | null;
};

export type AddExternalCoverageMutation = {
  addExternalCoverage: {
    __typename: "AddCoverageDetails";
    resident: {
      __typename: "Resident";
      id: string;
      residentId: string;
      firstName: string;
      lastName: string;
      siteAddress: {
        __typename: "SiteAddress";
        addressLine1: string;
        city: string;
        lotUnit?: string | null;
        spaceCode?: string | null;
        state: string;
        type?: string | null;
        zipCode: string;
      };
      insuranceAdoption: {
        __typename: "InsuranceAdoption";
        description: string;
        status: InsuranceAdoptionStatus;
      };
      policyType?: PolicyType | null;
      community: {
        __typename: "Community";
        ctmhcId: string;
        integrationId?: string | null;
        integrationType?: PortfolioIntegrationType | null;
        isActive: boolean;
        legalEntityCommunityOwnerId: string;
        name: string;
        portfolio: {
          __typename: "Portfolio";
          id: string;
          integrationId?: string | null;
          integrationType?: PortfolioIntegrationType | null;
          isActive: boolean;
          name: string;
        };
        displayId?: string | null;
        propertyId: string;
      };
      createdAt: number;
      updatedAt: number;
      email?: string | null;
      phoneNumber?: string | null;
      isCurrentResident: boolean;
      isPermanentlyExcluded: boolean;
      wasOptedIn?: boolean | null;
      moveInDate: string;
      moveOutDate?: string | null;
      sos?: string | null;
      isNariWorkflowApplicable: boolean;
      lease?: {
        __typename: "LeaseDetails";
        addendumDate?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        description?: string | null;
      } | null;
      leaseRequirements: {
        __typename: "LeaseRequirements";
        animalLiabilityLimit: number;
        leaseLimit: number;
        medicalPaymentsLimit: number;
      };
      policyholderLocator?: string | null;
      coverages: Array<{
        __typename: "Coverage";
        id: string;
        agencyAddress?: string | null;
        agencyEmail?: string | null;
        agencyName?: string | null;
        agencyPhoneNumber?: string | null;
        annualCost: number;
        coverageDetails?: {
          __typename: "CoverageDetails";
          occupancy?: string | null;
          manufacturer?: string | null;
          homeType?: HomeType | null;
          modelYear?: number | null;
          animalLiabilityLimit?: number | null;
          blanketRentalResidentLiabilityLimit?: number | null;
          homeCoverageLimit?: number | null;
          otherStructuresLimit?: number | null;
          personalLiabilityLimit?: number | null;
          premisesLiabilityLimit?: number | null;
          personalPropertyLimit?: number | null;
          residentLiabilityLimit?: number | null;
          standardDeductibleLimit?: number | null;
          medicalPaymentsLimit?: number | null;
        } | null;
        createdAt: number;
        documents: Array<{
          __typename: "CoverageDocument";
          id: string;
          name: string;
          description?: string | null;
        }>;
        events: Array<{
          __typename: "CoverageEvent";
          id: string;
          type: CoverageEventType;
          date: string;
          eventData: {
            __typename: "CoveragePictureForEvent";
            agencyName?: string | null;
            agencyAddress?: string | null;
            agencyPhoneNumber?: string | null;
            agencyEmail?: string | null;
            isInternalSale?: boolean | null;
            insuranceCarrierName: string;
            isActive: boolean;
            coverageDetails?: {
              __typename: "CoverageDetails";
              occupancy?: string | null;
              manufacturer?: string | null;
              homeType?: HomeType | null;
              modelYear?: number | null;
              animalLiabilityLimit?: number | null;
              blanketRentalResidentLiabilityLimit?: number | null;
              homeCoverageLimit?: number | null;
              otherStructuresLimit?: number | null;
              personalLiabilityLimit?: number | null;
              premisesLiabilityLimit?: number | null;
              personalPropertyLimit?: number | null;
              residentLiabilityLimit?: number | null;
              standardDeductibleLimit?: number | null;
              medicalPaymentsLimit?: number | null;
            } | null;
            policyId: string;
            policyDescription?: string | null;
            termEffectiveDate: string;
            termEndDate: string;
            annualCost: number;
          };
        }>;
        insuranceCarrierName: string;
        isActive: boolean;
        isInternalSale?: boolean | null;
        policyCancellationEffectiveDate?: string | null;
        policyCancellationReason?: string | null;
        policyDescription?: string | null;
        policyEffectiveDate: string;
        policyEndDate?: string | null;
        policyEndReason?: string | null;
        policyId: string;
        policyIssuedDate?: string | null;
        policyStatus?: PolicyStatus | null;
        policyType: PolicyType;
        updatedAt: number;
        updatedBy?: string | null;
      }>;
      physicalMailNotificationEvents: Array<{
        __typename: "PhysicalMailNotificationEvent";
        id: string;
        additionalData: string;
        eventType: PhysicalMailEventType;
        eventDate: string;
      }>;
    };
    alreadyAddedCoverageId?: string | null;
    alreadyAddedCoverageStatus?: TllCoverageStatus | null;
    cancelledCoverage?: {
      __typename: "Coverage";
      id: string;
      agencyAddress?: string | null;
      agencyEmail?: string | null;
      agencyName?: string | null;
      agencyPhoneNumber?: string | null;
      annualCost: number;
      coverageDetails?: {
        __typename: "CoverageDetails";
        occupancy?: string | null;
        manufacturer?: string | null;
        homeType?: HomeType | null;
        modelYear?: number | null;
        animalLiabilityLimit?: number | null;
        blanketRentalResidentLiabilityLimit?: number | null;
        homeCoverageLimit?: number | null;
        otherStructuresLimit?: number | null;
        personalLiabilityLimit?: number | null;
        premisesLiabilityLimit?: number | null;
        personalPropertyLimit?: number | null;
        residentLiabilityLimit?: number | null;
        standardDeductibleLimit?: number | null;
        medicalPaymentsLimit?: number | null;
      } | null;
      createdAt: number;
      documents: Array<{
        __typename: "CoverageDocument";
        id: string;
        name: string;
        description?: string | null;
      }>;
      events: Array<{
        __typename: "CoverageEvent";
        id: string;
        type: CoverageEventType;
        date: string;
        eventData: {
          __typename: "CoveragePictureForEvent";
          agencyName?: string | null;
          agencyAddress?: string | null;
          agencyPhoneNumber?: string | null;
          agencyEmail?: string | null;
          isInternalSale?: boolean | null;
          insuranceCarrierName: string;
          isActive: boolean;
          coverageDetails?: {
            __typename: "CoverageDetails";
            occupancy?: string | null;
            manufacturer?: string | null;
            homeType?: HomeType | null;
            modelYear?: number | null;
            animalLiabilityLimit?: number | null;
            blanketRentalResidentLiabilityLimit?: number | null;
            homeCoverageLimit?: number | null;
            otherStructuresLimit?: number | null;
            personalLiabilityLimit?: number | null;
            premisesLiabilityLimit?: number | null;
            personalPropertyLimit?: number | null;
            residentLiabilityLimit?: number | null;
            standardDeductibleLimit?: number | null;
            medicalPaymentsLimit?: number | null;
          } | null;
          policyId: string;
          policyDescription?: string | null;
          termEffectiveDate: string;
          termEndDate: string;
          annualCost: number;
        };
      }>;
      insuranceCarrierName: string;
      isActive: boolean;
      isInternalSale?: boolean | null;
      policyCancellationEffectiveDate?: string | null;
      policyCancellationReason?: string | null;
      policyDescription?: string | null;
      policyEffectiveDate: string;
      policyEndDate?: string | null;
      policyEndReason?: string | null;
      policyId: string;
      policyIssuedDate?: string | null;
      policyStatus?: PolicyStatus | null;
      policyType: PolicyType;
      updatedAt: number;
      updatedBy?: string | null;
    } | null;
    residentStatusChanged?: boolean | null;
  };
};

export type AddCovertreeCoverageMutationVariables = {
  policyLocator: string;
  residentId: string;
};

export type AddCovertreeCoverageMutation = {
  addCovertreeCoverage: {
    __typename: "AddCoverageDetails";
    resident: {
      __typename: "Resident";
      id: string;
      residentId: string;
      firstName: string;
      lastName: string;
      siteAddress: {
        __typename: "SiteAddress";
        addressLine1: string;
        city: string;
        lotUnit?: string | null;
        spaceCode?: string | null;
        state: string;
        type?: string | null;
        zipCode: string;
      };
      insuranceAdoption: {
        __typename: "InsuranceAdoption";
        description: string;
        status: InsuranceAdoptionStatus;
      };
      policyType?: PolicyType | null;
      community: {
        __typename: "Community";
        ctmhcId: string;
        integrationId?: string | null;
        integrationType?: PortfolioIntegrationType | null;
        isActive: boolean;
        legalEntityCommunityOwnerId: string;
        name: string;
        portfolio: {
          __typename: "Portfolio";
          id: string;
          integrationId?: string | null;
          integrationType?: PortfolioIntegrationType | null;
          isActive: boolean;
          name: string;
        };
        displayId?: string | null;
        propertyId: string;
      };
      createdAt: number;
      updatedAt: number;
      email?: string | null;
      phoneNumber?: string | null;
      isCurrentResident: boolean;
      isPermanentlyExcluded: boolean;
      wasOptedIn?: boolean | null;
      moveInDate: string;
      moveOutDate?: string | null;
      sos?: string | null;
      isNariWorkflowApplicable: boolean;
      lease?: {
        __typename: "LeaseDetails";
        addendumDate?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        description?: string | null;
      } | null;
      leaseRequirements: {
        __typename: "LeaseRequirements";
        animalLiabilityLimit: number;
        leaseLimit: number;
        medicalPaymentsLimit: number;
      };
      policyholderLocator?: string | null;
      coverages: Array<{
        __typename: "Coverage";
        id: string;
        agencyAddress?: string | null;
        agencyEmail?: string | null;
        agencyName?: string | null;
        agencyPhoneNumber?: string | null;
        annualCost: number;
        coverageDetails?: {
          __typename: "CoverageDetails";
          occupancy?: string | null;
          manufacturer?: string | null;
          homeType?: HomeType | null;
          modelYear?: number | null;
          animalLiabilityLimit?: number | null;
          blanketRentalResidentLiabilityLimit?: number | null;
          homeCoverageLimit?: number | null;
          otherStructuresLimit?: number | null;
          personalLiabilityLimit?: number | null;
          premisesLiabilityLimit?: number | null;
          personalPropertyLimit?: number | null;
          residentLiabilityLimit?: number | null;
          standardDeductibleLimit?: number | null;
          medicalPaymentsLimit?: number | null;
        } | null;
        createdAt: number;
        documents: Array<{
          __typename: "CoverageDocument";
          id: string;
          name: string;
          description?: string | null;
        }>;
        events: Array<{
          __typename: "CoverageEvent";
          id: string;
          type: CoverageEventType;
          date: string;
          eventData: {
            __typename: "CoveragePictureForEvent";
            agencyName?: string | null;
            agencyAddress?: string | null;
            agencyPhoneNumber?: string | null;
            agencyEmail?: string | null;
            isInternalSale?: boolean | null;
            insuranceCarrierName: string;
            isActive: boolean;
            coverageDetails?: {
              __typename: "CoverageDetails";
              occupancy?: string | null;
              manufacturer?: string | null;
              homeType?: HomeType | null;
              modelYear?: number | null;
              animalLiabilityLimit?: number | null;
              blanketRentalResidentLiabilityLimit?: number | null;
              homeCoverageLimit?: number | null;
              otherStructuresLimit?: number | null;
              personalLiabilityLimit?: number | null;
              premisesLiabilityLimit?: number | null;
              personalPropertyLimit?: number | null;
              residentLiabilityLimit?: number | null;
              standardDeductibleLimit?: number | null;
              medicalPaymentsLimit?: number | null;
            } | null;
            policyId: string;
            policyDescription?: string | null;
            termEffectiveDate: string;
            termEndDate: string;
            annualCost: number;
          };
        }>;
        insuranceCarrierName: string;
        isActive: boolean;
        isInternalSale?: boolean | null;
        policyCancellationEffectiveDate?: string | null;
        policyCancellationReason?: string | null;
        policyDescription?: string | null;
        policyEffectiveDate: string;
        policyEndDate?: string | null;
        policyEndReason?: string | null;
        policyId: string;
        policyIssuedDate?: string | null;
        policyStatus?: PolicyStatus | null;
        policyType: PolicyType;
        updatedAt: number;
        updatedBy?: string | null;
      }>;
      physicalMailNotificationEvents: Array<{
        __typename: "PhysicalMailNotificationEvent";
        id: string;
        additionalData: string;
        eventType: PhysicalMailEventType;
        eventDate: string;
      }>;
    };
    alreadyAddedCoverageId?: string | null;
    alreadyAddedCoverageStatus?: TllCoverageStatus | null;
    cancelledCoverage?: {
      __typename: "Coverage";
      id: string;
      agencyAddress?: string | null;
      agencyEmail?: string | null;
      agencyName?: string | null;
      agencyPhoneNumber?: string | null;
      annualCost: number;
      coverageDetails?: {
        __typename: "CoverageDetails";
        occupancy?: string | null;
        manufacturer?: string | null;
        homeType?: HomeType | null;
        modelYear?: number | null;
        animalLiabilityLimit?: number | null;
        blanketRentalResidentLiabilityLimit?: number | null;
        homeCoverageLimit?: number | null;
        otherStructuresLimit?: number | null;
        personalLiabilityLimit?: number | null;
        premisesLiabilityLimit?: number | null;
        personalPropertyLimit?: number | null;
        residentLiabilityLimit?: number | null;
        standardDeductibleLimit?: number | null;
        medicalPaymentsLimit?: number | null;
      } | null;
      createdAt: number;
      documents: Array<{
        __typename: "CoverageDocument";
        id: string;
        name: string;
        description?: string | null;
      }>;
      events: Array<{
        __typename: "CoverageEvent";
        id: string;
        type: CoverageEventType;
        date: string;
        eventData: {
          __typename: "CoveragePictureForEvent";
          agencyName?: string | null;
          agencyAddress?: string | null;
          agencyPhoneNumber?: string | null;
          agencyEmail?: string | null;
          isInternalSale?: boolean | null;
          insuranceCarrierName: string;
          isActive: boolean;
          coverageDetails?: {
            __typename: "CoverageDetails";
            occupancy?: string | null;
            manufacturer?: string | null;
            homeType?: HomeType | null;
            modelYear?: number | null;
            animalLiabilityLimit?: number | null;
            blanketRentalResidentLiabilityLimit?: number | null;
            homeCoverageLimit?: number | null;
            otherStructuresLimit?: number | null;
            personalLiabilityLimit?: number | null;
            premisesLiabilityLimit?: number | null;
            personalPropertyLimit?: number | null;
            residentLiabilityLimit?: number | null;
            standardDeductibleLimit?: number | null;
            medicalPaymentsLimit?: number | null;
          } | null;
          policyId: string;
          policyDescription?: string | null;
          termEffectiveDate: string;
          termEndDate: string;
          annualCost: number;
        };
      }>;
      insuranceCarrierName: string;
      isActive: boolean;
      isInternalSale?: boolean | null;
      policyCancellationEffectiveDate?: string | null;
      policyCancellationReason?: string | null;
      policyDescription?: string | null;
      policyEffectiveDate: string;
      policyEndDate?: string | null;
      policyEndReason?: string | null;
      policyId: string;
      policyIssuedDate?: string | null;
      policyStatus?: PolicyStatus | null;
      policyType: PolicyType;
      updatedAt: number;
      updatedBy?: string | null;
    } | null;
    residentStatusChanged?: boolean | null;
  };
};

export type AddCoverageEventMutationVariables = {
  coverageEvent: CoverageEventInput;
  residentId: string;
  coverageId: string;
};

export type AddCoverageEventMutation = {
  addCoverageEvent: {
    __typename: "Resident";
    id: string;
    residentId: string;
    firstName: string;
    lastName: string;
    siteAddress: {
      __typename: "SiteAddress";
      addressLine1: string;
      city: string;
      lotUnit?: string | null;
      spaceCode?: string | null;
      state: string;
      type?: string | null;
      zipCode: string;
    };
    insuranceAdoption: {
      __typename: "InsuranceAdoption";
      description: string;
      status: InsuranceAdoptionStatus;
    };
    policyType?: PolicyType | null;
    community: {
      __typename: "Community";
      ctmhcId: string;
      integrationId?: string | null;
      integrationType?: PortfolioIntegrationType | null;
      isActive: boolean;
      legalEntityCommunityOwnerId: string;
      name: string;
      portfolio: {
        __typename: "Portfolio";
        id: string;
        integrationId?: string | null;
        integrationType?: PortfolioIntegrationType | null;
        isActive: boolean;
        name: string;
      };
      displayId?: string | null;
      propertyId: string;
    };
    createdAt: number;
    updatedAt: number;
    email?: string | null;
    phoneNumber?: string | null;
    isCurrentResident: boolean;
    isPermanentlyExcluded: boolean;
    wasOptedIn?: boolean | null;
    moveInDate: string;
    moveOutDate?: string | null;
    sos?: string | null;
    isNariWorkflowApplicable: boolean;
    lease?: {
      __typename: "LeaseDetails";
      addendumDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      description?: string | null;
    } | null;
    leaseRequirements: {
      __typename: "LeaseRequirements";
      animalLiabilityLimit: number;
      leaseLimit: number;
      medicalPaymentsLimit: number;
    };
    policyholderLocator?: string | null;
    coverages: Array<{
      __typename: "Coverage";
      id: string;
      agencyAddress?: string | null;
      agencyEmail?: string | null;
      agencyName?: string | null;
      agencyPhoneNumber?: string | null;
      annualCost: number;
      coverageDetails?: {
        __typename: "CoverageDetails";
        occupancy?: string | null;
        manufacturer?: string | null;
        homeType?: HomeType | null;
        modelYear?: number | null;
        animalLiabilityLimit?: number | null;
        blanketRentalResidentLiabilityLimit?: number | null;
        homeCoverageLimit?: number | null;
        otherStructuresLimit?: number | null;
        personalLiabilityLimit?: number | null;
        premisesLiabilityLimit?: number | null;
        personalPropertyLimit?: number | null;
        residentLiabilityLimit?: number | null;
        standardDeductibleLimit?: number | null;
        medicalPaymentsLimit?: number | null;
      } | null;
      createdAt: number;
      documents: Array<{
        __typename: "CoverageDocument";
        id: string;
        name: string;
        description?: string | null;
      }>;
      events: Array<{
        __typename: "CoverageEvent";
        id: string;
        type: CoverageEventType;
        date: string;
        eventData: {
          __typename: "CoveragePictureForEvent";
          agencyName?: string | null;
          agencyAddress?: string | null;
          agencyPhoneNumber?: string | null;
          agencyEmail?: string | null;
          isInternalSale?: boolean | null;
          insuranceCarrierName: string;
          isActive: boolean;
          coverageDetails?: {
            __typename: "CoverageDetails";
            occupancy?: string | null;
            manufacturer?: string | null;
            homeType?: HomeType | null;
            modelYear?: number | null;
            animalLiabilityLimit?: number | null;
            blanketRentalResidentLiabilityLimit?: number | null;
            homeCoverageLimit?: number | null;
            otherStructuresLimit?: number | null;
            personalLiabilityLimit?: number | null;
            premisesLiabilityLimit?: number | null;
            personalPropertyLimit?: number | null;
            residentLiabilityLimit?: number | null;
            standardDeductibleLimit?: number | null;
            medicalPaymentsLimit?: number | null;
          } | null;
          policyId: string;
          policyDescription?: string | null;
          termEffectiveDate: string;
          termEndDate: string;
          annualCost: number;
        };
      }>;
      insuranceCarrierName: string;
      isActive: boolean;
      isInternalSale?: boolean | null;
      policyCancellationEffectiveDate?: string | null;
      policyCancellationReason?: string | null;
      policyDescription?: string | null;
      policyEffectiveDate: string;
      policyEndDate?: string | null;
      policyEndReason?: string | null;
      policyId: string;
      policyIssuedDate?: string | null;
      policyStatus?: PolicyStatus | null;
      policyType: PolicyType;
      updatedAt: number;
      updatedBy?: string | null;
    }>;
    physicalMailNotificationEvents: Array<{
      __typename: "PhysicalMailNotificationEvent";
      id: string;
      additionalData: string;
      eventType: PhysicalMailEventType;
      eventDate: string;
    }>;
  };
};

export type SearchResidentsQueryVariables = {
  pagination?: PaginationInput | null;
  query: string;
};

export type SearchResidentsQuery = {
  searchResidents: {
    __typename: "GetResidentsResponse";
    items: Array<{
      __typename: "Resident";
      id: string;
      residentId: string;
      firstName: string;
      lastName: string;
      siteAddress: {
        __typename: "SiteAddress";
        addressLine1: string;
        city: string;
        lotUnit?: string | null;
        spaceCode?: string | null;
        state: string;
        type?: string | null;
        zipCode: string;
      };
      insuranceAdoption: {
        __typename: "InsuranceAdoption";
        description: string;
        status: InsuranceAdoptionStatus;
      };
      policyType?: PolicyType | null;
      community: {
        __typename: "Community";
        ctmhcId: string;
        integrationId?: string | null;
        integrationType?: PortfolioIntegrationType | null;
        isActive: boolean;
        legalEntityCommunityOwnerId: string;
        name: string;
        portfolio: {
          __typename: "Portfolio";
          id: string;
          integrationId?: string | null;
          integrationType?: PortfolioIntegrationType | null;
          isActive: boolean;
          name: string;
        };
        displayId?: string | null;
        propertyId: string;
      };
      createdAt: number;
      updatedAt: number;
      email?: string | null;
      phoneNumber?: string | null;
      isCurrentResident: boolean;
      isPermanentlyExcluded: boolean;
      wasOptedIn?: boolean | null;
      moveInDate: string;
      moveOutDate?: string | null;
      sos?: string | null;
      isNariWorkflowApplicable: boolean;
      lease?: {
        __typename: "LeaseDetails";
        addendumDate?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        description?: string | null;
      } | null;
      leaseRequirements: {
        __typename: "LeaseRequirements";
        animalLiabilityLimit: number;
        leaseLimit: number;
        medicalPaymentsLimit: number;
      };
      policyholderLocator?: string | null;
      coverages: Array<{
        __typename: "Coverage";
        id: string;
        agencyAddress?: string | null;
        agencyEmail?: string | null;
        agencyName?: string | null;
        agencyPhoneNumber?: string | null;
        annualCost: number;
        coverageDetails?: {
          __typename: "CoverageDetails";
          occupancy?: string | null;
          manufacturer?: string | null;
          homeType?: HomeType | null;
          modelYear?: number | null;
          animalLiabilityLimit?: number | null;
          blanketRentalResidentLiabilityLimit?: number | null;
          homeCoverageLimit?: number | null;
          otherStructuresLimit?: number | null;
          personalLiabilityLimit?: number | null;
          premisesLiabilityLimit?: number | null;
          personalPropertyLimit?: number | null;
          residentLiabilityLimit?: number | null;
          standardDeductibleLimit?: number | null;
          medicalPaymentsLimit?: number | null;
        } | null;
        createdAt: number;
        documents: Array<{
          __typename: "CoverageDocument";
          id: string;
          name: string;
          description?: string | null;
        }>;
        events: Array<{
          __typename: "CoverageEvent";
          id: string;
          type: CoverageEventType;
          date: string;
          eventData: {
            __typename: "CoveragePictureForEvent";
            agencyName?: string | null;
            agencyAddress?: string | null;
            agencyPhoneNumber?: string | null;
            agencyEmail?: string | null;
            isInternalSale?: boolean | null;
            insuranceCarrierName: string;
            isActive: boolean;
            coverageDetails?: {
              __typename: "CoverageDetails";
              occupancy?: string | null;
              manufacturer?: string | null;
              homeType?: HomeType | null;
              modelYear?: number | null;
              animalLiabilityLimit?: number | null;
              blanketRentalResidentLiabilityLimit?: number | null;
              homeCoverageLimit?: number | null;
              otherStructuresLimit?: number | null;
              personalLiabilityLimit?: number | null;
              premisesLiabilityLimit?: number | null;
              personalPropertyLimit?: number | null;
              residentLiabilityLimit?: number | null;
              standardDeductibleLimit?: number | null;
              medicalPaymentsLimit?: number | null;
            } | null;
            policyId: string;
            policyDescription?: string | null;
            termEffectiveDate: string;
            termEndDate: string;
            annualCost: number;
          };
        }>;
        insuranceCarrierName: string;
        isActive: boolean;
        isInternalSale?: boolean | null;
        policyCancellationEffectiveDate?: string | null;
        policyCancellationReason?: string | null;
        policyDescription?: string | null;
        policyEffectiveDate: string;
        policyEndDate?: string | null;
        policyEndReason?: string | null;
        policyId: string;
        policyIssuedDate?: string | null;
        policyStatus?: PolicyStatus | null;
        policyType: PolicyType;
        updatedAt: number;
        updatedBy?: string | null;
      }>;
      physicalMailNotificationEvents: Array<{
        __typename: "PhysicalMailNotificationEvent";
        id: string;
        additionalData: string;
        eventType: PhysicalMailEventType;
        eventDate: string;
      }>;
    }>;
    pagination: {
      __typename: "PaginationResult";
      from: number;
      size: number;
      total: number;
    };
  };
};

export type GetReviewDetailsQueryVariables = {
  id: string;
};

export type GetReviewDetailsQuery = {
  getReviewDetails: {
    __typename: "ComplianceReview";
    id: string;
    startedAt: string;
    startReason: string;
    endedAt?: string | null;
    endReason?: string | null;
    expectedEndDate?: string | null;
  };
};

export type GetResidentsQueryVariables = {
  pagination?: PaginationInput | null;
  sorting?: GetResidentsSortByInput | null;
  filter?: GetResidentsFilterStatusInput | null;
};

export type GetResidentsQuery = {
  getResidents: {
    __typename: "GetResidentsResponse";
    items: Array<{
      __typename: "Resident";
      id: string;
      residentId: string;
      firstName: string;
      lastName: string;
      siteAddress: {
        __typename: "SiteAddress";
        addressLine1: string;
        city: string;
        lotUnit?: string | null;
        spaceCode?: string | null;
        state: string;
        type?: string | null;
        zipCode: string;
      };
      insuranceAdoption: {
        __typename: "InsuranceAdoption";
        description: string;
        status: InsuranceAdoptionStatus;
      };
      policyType?: PolicyType | null;
      community: {
        __typename: "Community";
        ctmhcId: string;
        integrationId?: string | null;
        integrationType?: PortfolioIntegrationType | null;
        isActive: boolean;
        legalEntityCommunityOwnerId: string;
        name: string;
        portfolio: {
          __typename: "Portfolio";
          id: string;
          integrationId?: string | null;
          integrationType?: PortfolioIntegrationType | null;
          isActive: boolean;
          name: string;
        };
        displayId?: string | null;
        propertyId: string;
      };
      createdAt: number;
      updatedAt: number;
      email?: string | null;
      phoneNumber?: string | null;
      isCurrentResident: boolean;
      isPermanentlyExcluded: boolean;
      wasOptedIn?: boolean | null;
      moveInDate: string;
      moveOutDate?: string | null;
      sos?: string | null;
      isNariWorkflowApplicable: boolean;
      lease?: {
        __typename: "LeaseDetails";
        addendumDate?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        description?: string | null;
      } | null;
      leaseRequirements: {
        __typename: "LeaseRequirements";
        animalLiabilityLimit: number;
        leaseLimit: number;
        medicalPaymentsLimit: number;
      };
      policyholderLocator?: string | null;
      coverages: Array<{
        __typename: "Coverage";
        id: string;
        agencyAddress?: string | null;
        agencyEmail?: string | null;
        agencyName?: string | null;
        agencyPhoneNumber?: string | null;
        annualCost: number;
        coverageDetails?: {
          __typename: "CoverageDetails";
          occupancy?: string | null;
          manufacturer?: string | null;
          homeType?: HomeType | null;
          modelYear?: number | null;
          animalLiabilityLimit?: number | null;
          blanketRentalResidentLiabilityLimit?: number | null;
          homeCoverageLimit?: number | null;
          otherStructuresLimit?: number | null;
          personalLiabilityLimit?: number | null;
          premisesLiabilityLimit?: number | null;
          personalPropertyLimit?: number | null;
          residentLiabilityLimit?: number | null;
          standardDeductibleLimit?: number | null;
          medicalPaymentsLimit?: number | null;
        } | null;
        createdAt: number;
        documents: Array<{
          __typename: "CoverageDocument";
          id: string;
          name: string;
          description?: string | null;
        }>;
        events: Array<{
          __typename: "CoverageEvent";
          id: string;
          type: CoverageEventType;
          date: string;
          eventData: {
            __typename: "CoveragePictureForEvent";
            agencyName?: string | null;
            agencyAddress?: string | null;
            agencyPhoneNumber?: string | null;
            agencyEmail?: string | null;
            isInternalSale?: boolean | null;
            insuranceCarrierName: string;
            isActive: boolean;
            coverageDetails?: {
              __typename: "CoverageDetails";
              occupancy?: string | null;
              manufacturer?: string | null;
              homeType?: HomeType | null;
              modelYear?: number | null;
              animalLiabilityLimit?: number | null;
              blanketRentalResidentLiabilityLimit?: number | null;
              homeCoverageLimit?: number | null;
              otherStructuresLimit?: number | null;
              personalLiabilityLimit?: number | null;
              premisesLiabilityLimit?: number | null;
              personalPropertyLimit?: number | null;
              residentLiabilityLimit?: number | null;
              standardDeductibleLimit?: number | null;
              medicalPaymentsLimit?: number | null;
            } | null;
            policyId: string;
            policyDescription?: string | null;
            termEffectiveDate: string;
            termEndDate: string;
            annualCost: number;
          };
        }>;
        insuranceCarrierName: string;
        isActive: boolean;
        isInternalSale?: boolean | null;
        policyCancellationEffectiveDate?: string | null;
        policyCancellationReason?: string | null;
        policyDescription?: string | null;
        policyEffectiveDate: string;
        policyEndDate?: string | null;
        policyEndReason?: string | null;
        policyId: string;
        policyIssuedDate?: string | null;
        policyStatus?: PolicyStatus | null;
        policyType: PolicyType;
        updatedAt: number;
        updatedBy?: string | null;
      }>;
      physicalMailNotificationEvents: Array<{
        __typename: "PhysicalMailNotificationEvent";
        id: string;
        additionalData: string;
        eventType: PhysicalMailEventType;
        eventDate: string;
      }>;
    }>;
    pagination: {
      __typename: "PaginationResult";
      from: number;
      size: number;
      total: number;
    };
  };
};

export type GetResidentQueryVariables = {
  id?: string | null;
};

export type GetResidentQuery = {
  getResident: {
    __typename: "Resident";
    id: string;
    residentId: string;
    firstName: string;
    lastName: string;
    siteAddress: {
      __typename: "SiteAddress";
      addressLine1: string;
      city: string;
      lotUnit?: string | null;
      spaceCode?: string | null;
      state: string;
      type?: string | null;
      zipCode: string;
    };
    insuranceAdoption: {
      __typename: "InsuranceAdoption";
      description: string;
      status: InsuranceAdoptionStatus;
    };
    policyType?: PolicyType | null;
    community: {
      __typename: "Community";
      ctmhcId: string;
      integrationId?: string | null;
      integrationType?: PortfolioIntegrationType | null;
      isActive: boolean;
      legalEntityCommunityOwnerId: string;
      name: string;
      portfolio: {
        __typename: "Portfolio";
        id: string;
        integrationId?: string | null;
        integrationType?: PortfolioIntegrationType | null;
        isActive: boolean;
        name: string;
      };
      displayId?: string | null;
      propertyId: string;
    };
    createdAt: number;
    updatedAt: number;
    email?: string | null;
    phoneNumber?: string | null;
    isCurrentResident: boolean;
    isPermanentlyExcluded: boolean;
    wasOptedIn?: boolean | null;
    moveInDate: string;
    moveOutDate?: string | null;
    sos?: string | null;
    isNariWorkflowApplicable: boolean;
    lease?: {
      __typename: "LeaseDetails";
      addendumDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      description?: string | null;
    } | null;
    leaseRequirements: {
      __typename: "LeaseRequirements";
      animalLiabilityLimit: number;
      leaseLimit: number;
      medicalPaymentsLimit: number;
    };
    policyholderLocator?: string | null;
    coverages: Array<{
      __typename: "Coverage";
      id: string;
      agencyAddress?: string | null;
      agencyEmail?: string | null;
      agencyName?: string | null;
      agencyPhoneNumber?: string | null;
      annualCost: number;
      coverageDetails?: {
        __typename: "CoverageDetails";
        occupancy?: string | null;
        manufacturer?: string | null;
        homeType?: HomeType | null;
        modelYear?: number | null;
        animalLiabilityLimit?: number | null;
        blanketRentalResidentLiabilityLimit?: number | null;
        homeCoverageLimit?: number | null;
        otherStructuresLimit?: number | null;
        personalLiabilityLimit?: number | null;
        premisesLiabilityLimit?: number | null;
        personalPropertyLimit?: number | null;
        residentLiabilityLimit?: number | null;
        standardDeductibleLimit?: number | null;
        medicalPaymentsLimit?: number | null;
      } | null;
      createdAt: number;
      documents: Array<{
        __typename: "CoverageDocument";
        id: string;
        name: string;
        description?: string | null;
      }>;
      events: Array<{
        __typename: "CoverageEvent";
        id: string;
        type: CoverageEventType;
        date: string;
        eventData: {
          __typename: "CoveragePictureForEvent";
          agencyName?: string | null;
          agencyAddress?: string | null;
          agencyPhoneNumber?: string | null;
          agencyEmail?: string | null;
          isInternalSale?: boolean | null;
          insuranceCarrierName: string;
          isActive: boolean;
          coverageDetails?: {
            __typename: "CoverageDetails";
            occupancy?: string | null;
            manufacturer?: string | null;
            homeType?: HomeType | null;
            modelYear?: number | null;
            animalLiabilityLimit?: number | null;
            blanketRentalResidentLiabilityLimit?: number | null;
            homeCoverageLimit?: number | null;
            otherStructuresLimit?: number | null;
            personalLiabilityLimit?: number | null;
            premisesLiabilityLimit?: number | null;
            personalPropertyLimit?: number | null;
            residentLiabilityLimit?: number | null;
            standardDeductibleLimit?: number | null;
            medicalPaymentsLimit?: number | null;
          } | null;
          policyId: string;
          policyDescription?: string | null;
          termEffectiveDate: string;
          termEndDate: string;
          annualCost: number;
        };
      }>;
      insuranceCarrierName: string;
      isActive: boolean;
      isInternalSale?: boolean | null;
      policyCancellationEffectiveDate?: string | null;
      policyCancellationReason?: string | null;
      policyDescription?: string | null;
      policyEffectiveDate: string;
      policyEndDate?: string | null;
      policyEndReason?: string | null;
      policyId: string;
      policyIssuedDate?: string | null;
      policyStatus?: PolicyStatus | null;
      policyType: PolicyType;
      updatedAt: number;
      updatedBy?: string | null;
    }>;
    physicalMailNotificationEvents: Array<{
      __typename: "PhysicalMailNotificationEvent";
      id: string;
      additionalData: string;
      eventType: PhysicalMailEventType;
      eventDate: string;
    }>;
  };
};

export type GetPortfoliosQuery = {
  getPortfolios: Array<{
    __typename: "Portfolio";
    id: string;
    integrationId?: string | null;
    integrationType?: PortfolioIntegrationType | null;
    isActive: boolean;
    name: string;
  }>;
};

export type GetParametersQueryVariables = {
  type: ParameterName;
  search: string;
};

export type GetParametersQuery = {
  getParameters: Array<string>;
};

export type GetDocumentUrlQueryVariables = {
  residentId: string;
  id: string;
};

export type GetDocumentUrlQuery = {
  getDocumentUrl: string;
};

export type GetCurrentUserResidentsQuery = {
  getCurrentUserResidents: Array<{
    __typename: "Resident";
    id: string;
    residentId: string;
    firstName: string;
    lastName: string;
    siteAddress: {
      __typename: "SiteAddress";
      addressLine1: string;
      city: string;
      lotUnit?: string | null;
      spaceCode?: string | null;
      state: string;
      type?: string | null;
      zipCode: string;
    };
    insuranceAdoption: {
      __typename: "InsuranceAdoption";
      description: string;
      status: InsuranceAdoptionStatus;
    };
    policyType?: PolicyType | null;
    community: {
      __typename: "Community";
      ctmhcId: string;
      integrationId?: string | null;
      integrationType?: PortfolioIntegrationType | null;
      isActive: boolean;
      legalEntityCommunityOwnerId: string;
      name: string;
      portfolio: {
        __typename: "Portfolio";
        id: string;
        integrationId?: string | null;
        integrationType?: PortfolioIntegrationType | null;
        isActive: boolean;
        name: string;
      };
      displayId?: string | null;
      propertyId: string;
    };
    createdAt: number;
    updatedAt: number;
    email?: string | null;
    phoneNumber?: string | null;
    isCurrentResident: boolean;
    isPermanentlyExcluded: boolean;
    wasOptedIn?: boolean | null;
    moveInDate: string;
    moveOutDate?: string | null;
    sos?: string | null;
    isNariWorkflowApplicable: boolean;
    lease?: {
      __typename: "LeaseDetails";
      addendumDate?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      description?: string | null;
    } | null;
    leaseRequirements: {
      __typename: "LeaseRequirements";
      animalLiabilityLimit: number;
      leaseLimit: number;
      medicalPaymentsLimit: number;
    };
    policyholderLocator?: string | null;
    coverages: Array<{
      __typename: "Coverage";
      id: string;
      agencyAddress?: string | null;
      agencyEmail?: string | null;
      agencyName?: string | null;
      agencyPhoneNumber?: string | null;
      annualCost: number;
      coverageDetails?: {
        __typename: "CoverageDetails";
        occupancy?: string | null;
        manufacturer?: string | null;
        homeType?: HomeType | null;
        modelYear?: number | null;
        animalLiabilityLimit?: number | null;
        blanketRentalResidentLiabilityLimit?: number | null;
        homeCoverageLimit?: number | null;
        otherStructuresLimit?: number | null;
        personalLiabilityLimit?: number | null;
        premisesLiabilityLimit?: number | null;
        personalPropertyLimit?: number | null;
        residentLiabilityLimit?: number | null;
        standardDeductibleLimit?: number | null;
        medicalPaymentsLimit?: number | null;
      } | null;
      createdAt: number;
      documents: Array<{
        __typename: "CoverageDocument";
        id: string;
        name: string;
        description?: string | null;
      }>;
      events: Array<{
        __typename: "CoverageEvent";
        id: string;
        type: CoverageEventType;
        date: string;
        eventData: {
          __typename: "CoveragePictureForEvent";
          agencyName?: string | null;
          agencyAddress?: string | null;
          agencyPhoneNumber?: string | null;
          agencyEmail?: string | null;
          isInternalSale?: boolean | null;
          insuranceCarrierName: string;
          isActive: boolean;
          coverageDetails?: {
            __typename: "CoverageDetails";
            occupancy?: string | null;
            manufacturer?: string | null;
            homeType?: HomeType | null;
            modelYear?: number | null;
            animalLiabilityLimit?: number | null;
            blanketRentalResidentLiabilityLimit?: number | null;
            homeCoverageLimit?: number | null;
            otherStructuresLimit?: number | null;
            personalLiabilityLimit?: number | null;
            premisesLiabilityLimit?: number | null;
            personalPropertyLimit?: number | null;
            residentLiabilityLimit?: number | null;
            standardDeductibleLimit?: number | null;
            medicalPaymentsLimit?: number | null;
          } | null;
          policyId: string;
          policyDescription?: string | null;
          termEffectiveDate: string;
          termEndDate: string;
          annualCost: number;
        };
      }>;
      insuranceCarrierName: string;
      isActive: boolean;
      isInternalSale?: boolean | null;
      policyCancellationEffectiveDate?: string | null;
      policyCancellationReason?: string | null;
      policyDescription?: string | null;
      policyEffectiveDate: string;
      policyEndDate?: string | null;
      policyEndReason?: string | null;
      policyId: string;
      policyIssuedDate?: string | null;
      policyStatus?: PolicyStatus | null;
      policyType: PolicyType;
      updatedAt: number;
      updatedBy?: string | null;
    }>;
    physicalMailNotificationEvents: Array<{
      __typename: "PhysicalMailNotificationEvent";
      id: string;
      additionalData: string;
      eventType: PhysicalMailEventType;
      eventDate: string;
    }>;
  }>;
};

export type GetCommunitiesForExistingPortfolioQueryVariables = {
  id: string;
};

export type GetCommunitiesForExistingPortfolioQuery = {
  getCommunitiesForExistingPortfolio: Array<{
    __typename: "Community";
    ctmhcId: string;
    integrationId?: string | null;
    integrationType?: PortfolioIntegrationType | null;
    isActive: boolean;
    legalEntityCommunityOwnerId: string;
    name: string;
    portfolio: {
      __typename: "Portfolio";
      id: string;
      integrationId?: string | null;
      integrationType?: PortfolioIntegrationType | null;
      isActive: boolean;
      name: string;
    };
    displayId?: string | null;
    propertyId: string;
  }>;
};

export type GetCommunityConfigurationQueryVariables = {
  portfolioId: string;
};

export type GetCommunityConfigurationQuery = {
  getCommunityConfiguration: {
    __typename: "CommunityConfiguration";
    communities: Array<{
      __typename: "CommunityConfigurationCommunity";
      addressLine1: string;
      addressLine2?: string | null;
      city: string;
      ctmhcId?: string | null;
      defaultAddendumDate?: string | null;
      displayId: string;
      isActive: boolean;
      name: string;
      ownerClientId?: string | null;
      propertyId: string;
      state: string;
      zipCode: string;
    }>;
    effectiveDate: string;
    effectiveTimestamp: number;
    owners: Array<{
      __typename: "CommunityConfigurationOwner";
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      clientId: string;
      county?: string | null;
      id?: string | null;
      municipality?: string | null;
      name?: string | null;
      state?: string | null;
      zipCode?: string | null;
    }>;
    policyDefaults?: {
      __typename: "CommunityConfigurationPolicyDefaults";
      limits: {
        __typename: "CommunityConfigurationPolicyLimits";
        animalLiabilityLimit?: number | null;
        blanketRentalResidentLiabilityLimit: number;
        medicalPaymentsLimit?: number | null;
        premisesLiabilityLimit?: number | null;
      };
      mgaFee: number;
      operatorFee: number;
      pricePerUnit: number;
    } | null;
    portfolio: {
      __typename: "CommunityConfigurationPortfolio";
      addressLine1: string;
      addressLine2?: string | null;
      city: string;
      county?: string | null;
      id: string;
      integrationId?: string | null;
      integrationType?: PortfolioIntegrationType | null;
      isActive: boolean;
      name: string;
      rentManagerLocations?: Array<{
        __typename: "CommunityConfigurationRentManagerLocation";
        glAccountId?: number | null;
        id: number;
        name: string;
      }> | null;
      rentManagerSettings?: {
        __typename: "CommunityConfigurationRentManagerSettings";
        liveNotesEnabled: boolean;
        shouldWriteDefaultUDFValues: boolean;
      } | null;
      state: string;
      zipCode: string;
    };
    states: Array<{
      __typename: "CommunityConfigurationState";
      localTaxes: Array<{
        __typename: "CommunityConfigurationLocalTaxes";
        cityName?: string | null;
        cityTaxRate?: number | null;
        countyName?: string | null;
        countyTaxRate?: number | null;
        otherLocalTaxes: Array<{
          __typename: "CommunityConfigurationOtherLocalTax";
          name: string;
          rate: number;
        }>;
        ownerClientId: string;
      }>;
      policyNumbers: Array<{
        __typename: "CommunityConfigurationPolicyNumber";
        ownerClientId: string;
        policyNumber?: string | null;
      }>;
      stampingFee?: number | null;
      state: string;
      stateTax?: number | null;
      surplusLinesTax: number;
    }>;
    taxDefaults: Array<{
      __typename: "CommunityConfigurationTaxDefault";
      otherFee?: {
        __typename: "CommunityConfigurationOtherFee";
        name: string;
        rate: number;
      } | null;
      stampingFee?: number | null;
      state: string;
      stateTax?: number | null;
      surplusLinesTax: number;
    }>;
  };
};

export type GetRentManagerGeneralLedgerAccountsQueryVariables = {
  portfolioId: string;
  locationId: number;
};

export type GetRentManagerGeneralLedgerAccountsQuery = {
  getRentManagerGeneralLedgerAccounts: Array<{
    __typename: "RentManagerGeneralLedgerAccount";
    description?: string | null;
    id: number;
    isActive: boolean;
    name: string;
  }>;
};
